import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import dashboardApi from 'apis/disApi/dashboardApi'
import { useSelector } from 'react-redux'
import { isJson } from '../../../../utils/functions/helpers'
import { orderBy } from 'lodash'
import { useMemo } from 'react'

export const dashboardKeys = {
	all: ['dashboards'],
	details: () => [...dashboardKeys.all, 'detail'],
	detail: (id) => [...dashboardKeys.details(), id],
}

export default function useDashboardQuery({ dashboardKey, enableConfig = true }) {
	const { environment } = useSelector((state) => state)
	const queryKey = dashboardKeys.detail(dashboardKey)
	const queryClient = useQueryClient()

	const { data, isLoading, error } = useQuery({
		queryKey,
		queryFn: () => dashboardApi.get(dashboardKey, environment.apiToken),
		enabled: Boolean(queryKey) && Boolean(dashboardKey) && enableConfig,
	})

	const dashboardKeyList = useMemo(
		() =>
			orderBy(
				data?.data?.variables && isJson(data?.data?.variables)
					? JSON.parse(data?.data?.variables ?? '{}')
					: [],
				['tileKey', 'key']
			),
		[data?.data?.variables]
	)

	const dashboardTileList = useMemo(() => {
		return data?.data?.tiles ?? []
	}, [data?.data])

	const updateMutation = useMutation(dashboardApi.update, {
		onSuccess: () => queryClient.invalidateQueries(queryKey),
	})

	const removeMutation = useMutation(dashboardApi.remove, {
		onSuccess: () => queryClient.invalidateQueries(queryKey),
	})

	return {
		isLoading,
		error,
		dashboardKeyList,
		updateMutation,
		removeMutation,
		dashboardTileList,
	}
}
